export default function (props: any) {
    return (
        <svg width="76" height="76" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h76v76H0z" />
                <g transform="translate(6 12)" stroke="#979797" strokeWidth="2">
                    <rect x="1" y="1" width="62" height="44" rx="4" />
                    <path strokeLinecap="round" d="M19 51.5h25.414" />
                </g>
            </g>
        </svg>
    );
}
